







import { MobileGetter } from 'frontend/types';
import { LearningPathV2 } from 'frontend/types/learningPathV2';
import { meta } from 'frontend/utils/decorators';
import { MetaDataProperty } from 'vue-meta/types/vue-meta';
import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import Desktop from './Desktop.vue';
import Mobile from './Mobile.vue';

@Component({
  components: {
    Desktop,
    Mobile,
  },
  computed: {
    ...mapGetters('learningPathV2', ['learningPath']),
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class LearningPath extends Vue {
  private readonly isMobile!: MobileGetter;
  private readonly learningPath!: LearningPathV2;

  @meta
  private metaInfo(): MetaDataProperty {
    return { title: `${this.learningPath.title}` };
  }
}
